import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * SharedDataTriggerService is service to handle app form validation
 */
@Injectable()
export class SharedDataTriggerService {

  // Observable to subscribe to the upload status changes
  private uploadStatusSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public uploadStatus$: Observable<boolean> = this.uploadStatusSubject.asObservable();

  // Observable to subscribe to the upload files changes
  private shareFilesUploadedSubject: BehaviorSubject<Array<string>> = new BehaviorSubject<Array<string>>([]);
  public shareFilesUploaded$: Observable<Array<string>> = this.shareFilesUploadedSubject.asObservable();


  // Observable to subscribe to the upload visible status changes
  private uploadVisibleStatusSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public uploadVisibleStatus$: Observable<boolean> = this.uploadVisibleStatusSubject.asObservable();

  /**
   * updateUploadStatus
   * @description Method to update the upload status
   * @param status
   */
  public updateUploadStatus (status: boolean): void {
    this.uploadStatusSubject.next(status);
  }

  /**
   * sharedUploadedFiles
   * @description Method to update the upload files
   * @param status
   */
  public sharedUploadedFiles (status: string[]): void {
    this.shareFilesUploadedSubject.next(status);
  }

  /**
   * updateUploadStatus
   * @description Method to update the upload status
   * @param status
   */
  public updateVisibleUploadStatus (status: boolean): void {
    this.uploadVisibleStatusSubject.next(status);
  }
}
